import { render, staticRenderFns } from "./IconInbox.vue?vue&type=template&id=c4dfa8e6&"
import script from "./IconInbox.vue?vue&type=script&lang=ts&"
export * from "./IconInbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports